(() => {
  if (customElements.get('nuwa-size-chart')) return;
  class NuwaSizeChart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('.nuwa-chart__units').hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-unit]');
        if (button && this.contains(button)) this.setUnit(button.dataset.unit);
      });
      this.setUnit(this.dataset.defaultUnit === 'cm' ? 'cm' : 'in');
    }
    setUnit(unit) {
      if (unit !== 'cm' && unit !== 'in') return;
      this.querySelectorAll('[data-measurement-cm]').forEach((cell) => {
        const value = cell.dataset.measurementCm;
        // Convert only numeric values and ranges; preserve placeholders and free text.
        const numeric = /^\s*\d+(?:\.\d+)?\s*(?:[-–—~～]\s*\d+(?:\.\d+)?\s*)?$/.test(value);
        if (cell.hasAttribute('data-height') && unit === 'in' && /^\s*\d+(?:\.\d+)?\s*$/.test(value)) {
          const totalInches = Math.round(Number(value) / 2.54);
          cell.textContent = `${Math.floor(totalInches / 12)}′${totalInches % 12}″`;
          return;
        }
        cell.textContent = unit === 'in' && numeric
          ? value.replace(/\d+(?:\.\d+)?/g, (number) => (Number(number) / 2.54).toFixed(1))
          : value || '—';
      });
      this.querySelectorAll('[data-unit-label]').forEach((label) => {
        label.textContent = label.hasAttribute('data-height-unit') && unit === 'in' ? '' : unit;
      });
      this.querySelectorAll('button[data-unit]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
      });
    }
  }
  customElements.define('nuwa-size-chart', NuwaSizeChart);
})();
